import { getApiBaseUrl } from '../api/client';

/**
 * Extra user fields the API's Better Auth instance exposes beyond the defaults.
 * Both frontends feed this into `inferAdditionalFields<AuthAdditionalFields>()` so
 * `session.user` is typed identically everywhere.
 *
 * Note: the auth *client instance* is intentionally created per app rather than by a
 * shared factory. Better Auth derives its client types from the exact plugin list
 * passed to `createAuthClient`, and routing that through a factory collapses those
 * inferred types to `any`. Each app therefore keeps a thin `auth-client.ts` that
 * imports this type and {@link getAuthBaseUrl}.
 */
export type AuthAdditionalFields = {
  user: {
    additionalFields: {
      tags: {
        type: 'string[]';
        defaultValue: [];
      };
      approved: {
        type: 'boolean';
        defaultValue: false;
      };
      data: {
        type: 'json';
        defaultValue: {};
      };
      approvedAt: {
        // drizzle timestamp mode: 'string' maps to string in JS
        type: 'string';
        required: false;
      };
      isAdmin: {
        type: 'boolean';
        defaultValue: false;
      };
      isPending: {
        type: 'boolean';
        defaultValue: false;
      };
      pointsBalance: {
        type: 'number';
        defaultValue: 0;
      };
      featureFlags: {
        type: 'string[]';
        defaultValue: [];
      };
    };
  };
};

/**
 * Base URL for the Better Auth routes, derived from the configured API base URL.
 * Respects `configureApiClient` so an app only has to set its API URL in one place.
 */
export function getAuthBaseUrl(): string {
  return `${getApiBaseUrl()}auth`;
}
